import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import adminApiClient, { BOAdminViewModel } from 'api/adminApiClient';
import { RootState } from './rootReducer';

interface AdminState {
  allAdmins: BOAdminViewModel[];
  isAllAdminsLoading: boolean;
}

const initialState: AdminState = {
  allAdmins: [],
  isAllAdminsLoading: false,
};

const getBOAdminsPagedList = createAsyncThunk(
  'admin/getBOAdminsPagedList',
  async ({
    pageNumber,
    pageSize,
  }: {
    pageNumber: number;
    pageSize: number;
  }) => {
    return adminApiClient.getBOAdminsPagedList(pageSize, pageNumber);
  },
);

const grantAdminRole = createAsyncThunk(
  'admin/grantAdminRole',
  async (userId: string) => {
    return adminApiClient.grantAdminRole(userId);
  },
);

const getMembersWithoutAdminRoleShort = createAsyncThunk(
  'admin/getMembersWithoutAdminRoleShort',
  async () => {
    return adminApiClient.getMembersWithoutAdminRoleShort();
  },
);

const getAllAdmins = createAsyncThunk(
  'admin/getAllAdmins',
  async () => {
    return adminApiClient.getActiveBOAdmins();
  },
  {
    condition: (_, { getState }) => {
      const { admin } = getState() as RootState;
      return !admin.allAdmins.length && !admin.isAllAdminsLoading;
    },
  },
);

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllAdmins.pending, (state) => {
      state.isAllAdminsLoading = true;
    });
    builder.addCase(getAllAdmins.fulfilled, (state, action) => {
      state.allAdmins = action.payload;
      state.isAllAdminsLoading = false;
    });
    builder.addCase(getAllAdmins.rejected, (state) => {
      state.isAllAdminsLoading = false;
    });
  },
});

const { reducer } = adminSlice;

export {
  getBOAdminsPagedList,
  grantAdminRole,
  getMembersWithoutAdminRoleShort,
  getAllAdmins,
};
export default reducer;
